import { useTheme } from '@practium/features/theme';
import { PolicyMetaButton } from '@practium/features/policy';
import { UniversalToggle } from '@practium/ui';
import type { Gateway } from '../../types/gateway.types';
import type { GatewayTheme } from '../../constants/gateway.themes';
import styles from './GatewayCard.module.css';

const formatDate = (dateStr: string): string => {
	const [year, month, day] = dateStr.split('-');
	return `${day}/${month}/${year.slice(2)}`;
};

interface GatewayCardProps {
	gateway: Gateway;
	theme: GatewayTheme;
	isActive: boolean;
	onToggle: (id: number, active: boolean) => void;
}

export const GatewayCard = ({ gateway, theme, isActive, onToggle }: GatewayCardProps) => {
	const { isDark } = useTheme();
	const titleParts = (isDark && theme.titlePartsDark) ? theme.titlePartsDark : theme.titleParts;
	const borderColor = (isDark && theme.borderColorDark) ? theme.borderColorDark : theme.borderColor;

	const cardVars = {
		'--gw-card-bg': isActive ? theme.cardBg : 'var(--bg-card)',
		'--gw-border': isActive ? borderColor : 'var(--policies-card-border-inactive)',
		'--gw-title': theme.titleColor,
	} as React.CSSProperties;

	return (
		<div className={`${styles.card} ${isActive ? styles.active : ''}`} style={cardVars}>
			<div className={styles.body}>
				<h3 className={styles.title}>
					{titleParts
						? titleParts.map((part, i) => (
								<span key={i} style={{ color: part.color }}>{part.text}</span>
							))
						: gateway.nome}
				</h3>
				<p className={styles.description}>{gateway.descricao}</p>
				<div className={styles.meta}>
					<PolicyMetaButton variant="version">Versão {gateway.versao}</PolicyMetaButton>
					<PolicyMetaButton variant="date">{formatDate(gateway.ultima_atualizacao)}</PolicyMetaButton>
				</div>
			</div>

			<div className={styles.footer}>
				<div
					className={styles.toggleWrapper}
					style={{ '--primary': isActive ? theme.toggleColor : undefined } as React.CSSProperties}
					onClick={(e) => e.stopPropagation()}
				>
					<UniversalToggle
						checked={isActive}
						onChangeToggle={(checked) => onToggle(gateway.id, checked)}
					/>
				</div>
			</div>
		</div>
	);
};
